"use client";
import React from "react";
import CustomModal from "./CustomModal";
import Icon from "../icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { closeHelpModal } from "@/redux/features/HelpModal/helpModalSlice";

export const HelpModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.helpModal.isOpen);

  const iconClass = "w-5 h-5 text-primaryBlack transition duration-300 ease-in-out group-hover:text-primaryBlue";

  const contactOptions = [
    {
      label: "Connect Us on WhatsApp",
      icon: <Icon.whatsappIconV2 className={iconClass} />,
      link: "https://wa.me/919660032889",
    },
    {
      label: "Call Us on +91-9660032889",
      icon: <Icon.callIconV2 className={iconClass} />,
      link: "tel:+919660032889",
    },
    {
      label: "Raise a Query",
      icon: <Icon.queryIconV2 className={iconClass} />,
      link: "https://dashboard.mysiponline.com/support-desk",
    },
    {
      label: "Connect Us on Email",
      icon: <Icon.emailIconV2 className={iconClass} />,
      link: "https://mail.google.com/mail/u/0/?fs=1&to=support@mysiponline.com&tf=cm",
    },
  ];

  return (
    <>
      <CustomModal isOpen={isOpen} onClose={() => dispatch(closeHelpModal())} maxSize="max-w-85 sm:max-w-112.5" className="rounded-t-6xl sm:rounded-6xl bg-white p-5 pt-0 sm:p-6 relative" useDragToClose isBlurOverlay>
        <p className="border-b border-dotted border-[#454545] pb-2.5 text-lg sm:text-xl line-clamp-5 font-semibold text-primaryBlue mb-4">Need Help? Reach out to us...</p>
        <ul className="space-y-3">
          {contactOptions.map(({ label, icon, link }, idx) => (
            <li key={idx}>
              <a href={link} target={link.startsWith("http") ? "_blank" : "_self"} className="flex items-center gap-2 w-full bg-[#C0C0C026] px-4 py-5 border border-[#0000001F] rounded-xl group shadow-[0_1px_2px_1px_#00000020] transition duration-300 hover:bg-[#EBF3FF]">
                {icon}
                <span className="text-sm md:text-base font-semibold text-center transition duration-300 ease-in-out group-hover:text-primaryBlue">{label}</span>
                <Icon.rightArrow className={`ml-auto ${iconClass}`} />
              </a>
            </li>
          ))}
        </ul>
      </CustomModal>
    </>
  );
};
